import Localize from 'react-intl-universal';

import * as yup from 'yup';

import { PASSWORD_REGEX } from '@common/Constants';

export default () => {
  return yup.object().shape({
    email: yup
      .string()
      .email(Localize.get('Validation.emailFilter'))
      .required(Localize.get('Validation.requiredField')),
    password: yup
      .string()
      .required(Localize.get('Validation.requiredField'))
      .min(8, Localize.get('MyProfile.minCharacter'))
      .matches(PASSWORD_REGEX, Localize.get('Validation.missingCondition')),
    firstName: yup.string().required(Localize.get('Validation.requiredField')),
    lastName: yup.string().required(Localize.get('Validation.requiredField')),
    companyName: yup.string().required(Localize.get('Validation.requiredField')),
    function: yup.string().required(Localize.get('Validation.requiredField')),
    privacy: yup.boolean().required(Localize.get('Validation.requiredField')).oneOf([true]),
    terms: yup.boolean().required(Localize.get('Validation.requiredField')).oneOf([true])
  });
};
